module.exports = __webpack_public_path__ + "img/red-1-squiggly-striped.111bc789.svg";